import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const CalendarTodayIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue935'}</MuiIcon>
        );
    }
)
